import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs/internal/Observable';
import { Mission, Organization } from '../../interfaces/culture.interface';

@Injectable({
  providedIn: 'root',
})
export class CultureService {
  constructor(private apiService: ApiService) {}

  getMissions(): Observable<Mission[]> {
    return this.apiService.buildAPIGet<Mission[]>('/stories/missions/');
  }

  getOneMission(id: string): Observable<Mission> {
    return this.apiService.buildAPIGetById<Mission>(
      '/stories/missions/',
      id + '/'
    );
  }

  updateMission(id: any, data: any): Observable<Mission> {
    return this.apiService.buildAPIPut<Mission>('/stories/missions/', id, data);
  }

  postMission(data: any): Observable<Mission> {
    return this.apiService.buildAPIPost<Mission>('/stories/missions/', data);
  }

  deleteMission(id: number): Observable<void> {
    return this.apiService.buildAPIDelete<void>('/stories/missions/', id);
  }

  getOrganizations(): Observable<Organization[]> {
    return this.apiService.buildAPIGet<Organization[]>(
      '/stories/organization/'
    );
  }

  getOneOrganization(id: string): Observable<Organization> {
    return this.apiService.buildAPIGetById<Organization>(
      '/stories/organization/',
      id + '/'
    );
  }

  deleteOrganization(id: number): Observable<void> {
    return this.apiService.buildAPIDelete<void>('/stories/organization/', id);
  }

  postOrganization(data: any): Observable<Organization> {
    return this.apiService.buildAPIPost<Organization>(
      '/stories/organization/',
      data
    );
  }

  updateOrganization(id: any, data: any): Observable<Organization> {
    return this.apiService.buildAPIPut<Organization>(
      '/stories/organization/',
      id,
      data
    );
  }
}
